import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import { FC, SyntheticEvent } from "react";
import AutocompleteField from "shared/components/Form/AutocompleteField";
import TextField from "shared/components/Form/TextField";
import FieldLabel from "shared/components/Form/components/FieldLabel";
import { COLOR_BLACK } from "shared/theme/colors";
import { CheckBoxIcon } from "shared/theme/icons/CheckBoxIcon";
import { CheckedBoxIcon } from "shared/theme/icons/CheckedBoxIcon";

export type StudioOption = {
  id: string;
  name: string;
};

type Props = {
  value: StudioOption[];
  options: StudioOption[];
  onChange: (value: StudioOption[]) => void;
  loading: boolean;
  placeholder: string;
  disabled?: boolean;
  label?: string;
};

const StudiosAutocomplete: FC<Props> = (props) => {
  const handleChange = (_: SyntheticEvent, value: StudioOption[]) => {
    props.onChange(value);
  };

  return (
    <AutocompleteField
      multiple
      disableCloseOnSelect
      id="studios-autocomplete"
      value={props.value}
      options={props.options}
      onChange={handleChange}
      disabled={props.disabled}
      loading={props.loading}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderOption={(props, option, { selected }) => {
        return (
          <li {...props} key={props.key}>
            <Checkbox
              icon={<CheckBoxIcon />}
              checkedIcon={<CheckedBoxIcon />}
              style={{ marginRight: 8 }}
              checked={selected}
              id={props.id}
            />
            <Typography color={COLOR_BLACK} variant="bodyMRegular">
              {option.name}
            </Typography>
          </li>
        );
      }}
      renderInput={(params) => (
        <>
          <FieldLabel />
          <TextField {...params} placeholder={props.placeholder} />
        </>
      )}
    />
  );
};

export default StudiosAutocomplete;
